/**
 * Activate a control on Enter / Space (for role="button" elements that are not <button>).
 * Prevents Space from scrolling the page.
 */
export default function onActivateKeyDown(event, activate) {
  if (!activate) return;
  const { key } = event;
  if (key !== 'Enter' && key !== ' ') return;
  event.preventDefault();
  activate(event);
}
